/**
 * Settings Page
 */

import React from 'react';

const Settings: React.FC = () => {
  return (
    <div>
      <h1 style={styles.title}>Settings</h1>
      <p style={styles.subtitle}>Platform configuration</p>
      
      <div style={styles.card}>
        <p>Platform settings - Coming soon</p>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  title: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#fff',
    margin: 0,
  },
  subtitle: {
    color: '#9ca3af',
    marginTop: '5px',
  },
  card: {
    background: '#1a1a2e',
    borderRadius: '12px',
    padding: '24px',
    border: '1px solid #252540',
    marginTop: '20px',
  },
};

export default Settings;
